import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import HighchartsReact from 'highcharts-react-official';

const Highcharts = window.Highcharts;

function CallTypeBreakdown({ chartData, isAutomotiveIndustry }) {
  const chartComponent = useRef();
  useEffect(() => {
    // This effect reflows the chart to its container whenever isAutomotiveIndustry
    // changes because this value determines whether or not the parent layout is 2 or
    // 3 columns. Without this effect, the container size will change when isAuotomotiveIndustry
    // changes but the chartComponent size will stay the size of the previous container.
    const chart = chartComponent.current.chart;
    chart.reflow();
  }, [isAutomotiveIndustry]);

  const chartOptions = {
    chart: {
      height: 300,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
    },
    title: {
      text: '',
    },
    tooltip: {
      pointFormat: '{point.y}',
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        colors: ['#74C372', '#428BCA', '#FFBF00', '#573B7A', '#E35D6A'],
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.0f} %',
          style: {
            color: (Highcharts?.theme && Highcharts?.theme.contrastTextColor) || 'black',
          },
        },
      },
    },
    exporting: { enabled: false },
    credits: { enabled: false },
    series: [
      {
        name: '',
        colorByPoint: true,
        data: chartData,
      },
    ],
  };
  return (
    <div className='report_data_container'>
      <div className='title'>Call Types</div>
      <HighchartsReact ref={chartComponent} highcharts={Highcharts} options={chartOptions} />
    </div>
  );
}

CallTypeBreakdown.propTypes = {
  chartData: PropTypes.array.isRequired,
  isAutomotiveIndustry: PropTypes.bool.isRequired,
};

export default CallTypeBreakdown;
